import Image from 'next/image';
import { motion, useInView } from 'framer-motion';
import { useInViewScroll } from 'ui';

interface NascarLogoProps {
    className?: string;
    margin?: string;
    zindex?: string;
    maxwidth?: string;
  }

export const NascarLogo = ({
    className = "",
    margin = "0 auto",
    zindex="41",
    maxwidth="unset"
}: NascarLogoProps) => {

    const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100vh', 'end 0vh']);
    const inView = useInView(ref, { once: true, margin: '-30% 0% -30% 0%' });

    return(
        <motion.div 
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 40 }}
            transition={{ ease: [0, 1, 1, 1] }}
            ref={ref}
            className={`flex w-full h-auto items-center ${className} ${Number(zindex) > 0 ? 'relative' : ''}`}
            style={{
                margin: margin,
                zIndex: zindex + " !important"
            }}
        >
            <Image
                src={'/nascar-xumo-logos.png'}
                alt={'nascar'}
                width="2688"
                height="578"
                className="img inline-block max-w-[650px] w-4/5"
                style={{ 
                    width: 'auto',
                    maxWidth: maxwidth
                }}
                sizes="100vw"
            />
        </motion.div>
    )
}